import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AccountService } from 'src/app/services/account.service';
import { ClientContactService } from 'src/app/services/client-contact.service';
import { ClientService } from 'src/app/services/client.service';
import { ProgramService } from 'src/app/services/program.service';

@Component({
  selector: 'app-program-contact',
  templateUrl: './program-contact.component.html',
  styleUrls: ['./program-contact.component.css'],
})
export class ProgramContactComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  activeTab = 'Program | Location';
  pageTabs = [
    'Program | Location',
    'Client Contact',
  ];
  addProgramForm: FormGroup;
  addClientContactForm: FormGroup;
  programLocationLimit: number = 20;
  programLocations: any[];
  programLocationTotal: number;
  programLocationPage: number = 1;
  @BlockUI('program-location-list-ui') programLocationsBlockUI: NgBlockUI;
  isProgramFormSubmitted: boolean;
  isClientContactFormSubmitted: boolean;
  serverDateFormat = 'yyyy-MM-dd';
  @BlockUI('client-contacts-ui') clientContactsBlockUI: NgBlockUI;
  clientContactLimit: number = 20;
  clientContactPage: number = 1;
  clientContacts: any[];
  clientContactTotal: any;

  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private clientService: ClientService,
    private fb: FormBuilder,
    private _datePipe: DatePipe,
    private toastr: ToastrService,
    private router: Router,
    private programService:ProgramService,
    private clientContactService:ClientContactService,
    private accountService:AccountService
  ) {
  }

  ngOnInit() {
    this.initForms();
    this.getProgramLocations();
    this.getClientContacts();
  }

  getProgramLocations() {
    this.programLocationsBlockUI.start();
    this.programService.getProgramLocations(this.programLocationLimit, this.programLocationPage).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (resp) => {
        const { hits, offset, estimatedTotalHits } = resp.details;
        this.programLocations = hits;
        this.programLocationTotal = estimatedTotalHits;
        this.programLocationsBlockUI.stop();
      },
      (error) => {
        this.programLocationsBlockUI.stop();
      }
    );
  }

  onPageChangeProgramLocations(event: any) {
    this.programLocationPage = event;
    this.getProgramLocations();
  }

  onSizeChangeProgramLocations(limit: number) {
    this.programLocationLimit = limit;
    this.programLocationPage = 1;
    this.getProgramLocations();
  }

  getClientContacts() {
    this.clientContactsBlockUI.start();
    this.clientContactService.getClientContacts(this.clientContactLimit, this.clientContactPage).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (resp) => {
        const { hits, offset, estimatedTotalHits } = resp.details;
        this.clientContacts = hits;
        this.clientContactTotal = estimatedTotalHits;
        this.clientContactsBlockUI.stop();
      },
      (error) => {
        this.clientContactsBlockUI.stop();
      }
    );
  }

  onPageChangeClientContacts(event: any) {
    this.programLocationPage = event;
    this.getProgramLocations();
  }

  onSizeChangeClientContacts(limit: number) {
    this.programLocationLimit = limit;
    this.programLocationPage = 1;
    this.getProgramLocations();
  }

  initForms(){
    this.addProgramForm = this.fb.group({
      program_name: new FormControl('', [Validators.required]),
      physical_address_1: new FormControl(''),
      physical_city: new FormControl(''),
      physical_state: new FormControl(''),
      physical_zip: new FormControl('', ),
      primary_phone: new FormControl(''),
      primary_email: new FormControl(''),
      billing_email: new FormControl(''),
      client_instructions: new FormControl(''),
      invoice_instructions: new FormControl(''),
      general_notes: new FormControl(''),
      client: new FormControl(this.route.snapshot.params.id),
    });

    this.addClientContactForm = this.fb.group({
      title: new FormControl('', [Validators.required]),
      first_name: new FormControl('', [Validators.required]),
      middle_name: new FormControl('', [Validators.required]),
      last_name: new FormControl('', [Validators.required]),
      email: new FormControl(''),
      work_phone: new FormControl(''),
      mobile_phone: new FormControl(''),
      social_security_number: new FormControl(''),
      dob: new FormControl(''),
      general_notes: new FormControl(''),
      client: new FormControl(this.route.snapshot.params.id),
      user: new FormControl(''),
    });
  }

  openPopup(content, size = 'md',service=this.modalService) {
    service.open(content, {
      ariaDescribedBy: 'modal-basic-title',
      windowClass: 'groupModal',
      size,
      centered: true,
    });
  }

  addProgram(){

    if (this.addProgramForm.invalid) {
      return;
    }

    this.addProgramForm.get('client').setValue(this.route.snapshot.params.id);

    this.isProgramFormSubmitted = true;

    this.programService
      .createProgram(this.addProgramForm.value)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.toastr.success(res?.details?.message);
          this.isProgramFormSubmitted = false;
          this.getProgramLocations();
          this.addProgramForm.reset();
          this.modalService.dismissAll();
        },
        (error) => {
          this.toastr.success(error?.errors[0]);
        }
      );

  }

  addNewProgram(){
    this.addProgramForm.reset();
  }

  saveClientContact(){
    if (this.addClientContactForm.invalid) {
      return;
    }

    let birthdate = this.addClientContactForm.get('dob').value;
    if (birthdate) {
      this.addClientContactForm
        .get('dob')
        .setValue(this._datePipe.transform(birthdate, this.serverDateFormat));
    }

    this.addClientContactForm.get('client').setValue(this.route.snapshot.params.id);
    // this.addClientContactForm.get('user').setValue(this.accountService.userInfo?.details?.id);

    this.isClientContactFormSubmitted = true;

    this.clientContactService
      .createClientContact(this.addClientContactForm.value)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.toastr.success(res?.details?.message);
          this.isClientContactFormSubmitted = false;
          this.getClientContacts();
          this.addClientContactForm.reset();
          this.modalService.dismissAll();
        },
        (error) => {
          this.toastr.success(error?.errors[0]);
        }
      );


  }

  addNewClientContact(){
    this.addClientContactForm.reset();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
